import { Spin, Tag } from 'antd';
import { colorConstants } from 'config/colorConstants';
import { useCountdownTimer } from 'hooks/general/useCountdownTimer';
import React, { useContext, useEffect, useState } from 'react';
import ConfirmationModal from './modals/ConfirmationModal';
import { antIcon } from '../Filter/FilterApplyButton';
import { tradePromoOptimizationUrls } from 'config/urls';
import { TPODataContext, initialPlanEditMetaData } from 'contexts/TPOContext';
import { useCommonMutationHandler } from 'hooks/general/useCommonMutationHandler';
import { compareUsers, generateErrorMsg, sendNotification } from 'utils/helperMethods';
import { ErrorMessages, tpoNotificationMessages } from 'utils/Enums';
import { queryClient } from 'services/reactQueryService';

const TimerDisplay = ({
    openSessionEndedConfirmationModal,
    setSessionEndedConfirmationModal,
}: {
    openSessionEndedConfirmationModal: {
        title: string;
        open: boolean;
    };
    setSessionEndedConfirmationModal: Function;
}) => {
    const { selectedPlanInfo, planEditMetaData, setPlanEditMetaData } = useContext(TPODataContext);
    const startSeconds = planEditMetaData.sessionExpiresInSecs ?? 0;
    const { hours, minutes, seconds, totalSeconds } = useCountdownTimer(startSeconds, planEditMetaData?.startedAt);
    const isInDangerZone = totalSeconds <= 600 && startSeconds > 0; //10 mins
    const hasSessionEnded = startSeconds > 0 && totalSeconds <= 0;
    useEffect(() => {
        if (isInDangerZone && !openSessionEndedConfirmationModal?.open) {
            setSessionEndedConfirmationModal({ open: true, title: 'Session will expire soon' });
        }
    }, [isInDangerZone]);

    useEffect(() => {
        if (hasSessionEnded) {
            setSessionEndedConfirmationModal({ open: false, title: '' });
            exitEditModeClickHandler();
        }
    }, [hasSessionEnded]);

    const { mutate: releasePlanEditFn, loading: releasePlanEditLoading } = useCommonMutationHandler({
        url: `${tradePromoOptimizationUrls.getPlanEditMetaDataUrl}/${selectedPlanInfo?.planId}/edit/release`,
        method: 'post',
    });

    function exitEditModeClickHandler() {
        if (releasePlanEditLoading) return;
        const payload = {
            user_id: localStorage.getItem('email'),
        };
        releasePlanEditFn(payload, {
            onSuccess: (data) => {
                sendNotification('success', tpoNotificationMessages.PLAN_EDIT_RELEASE_SUCCESS);
                //remove calender api from cache
                queryClient.removeQueries({ queryKey: ['tpo-event-data', 'tpo-calender-data'], exact: false });
                setPlanEditMetaData({
                    ...initialPlanEditMetaData,
                });
            },
            onError: (error: any) => {
                const errorMsg = generateErrorMsg(
                    String(error?.response?.data?.detail || ''),
                    ErrorMessages.GENERALIZED_ERROR_MSG,
                );
                //show error message
                sendNotification('error', errorMsg);
                setPlanEditMetaData({
                    ...initialPlanEditMetaData,
                });
            },
        });
    }

    return (
        <>
            <Tag
                className="cursor-pointer"
                onClick={() => {
                    setSessionEndedConfirmationModal({ open: true, title: 'Extend session' });
                }}
                style={{ borderRadius: 4 }}
                color={isInDangerZone ? 'volcano' : 'green'}
            >
                {totalSeconds <= 0 ? 'Session Expired' : `Session expires in - ${hours}: ${minutes}: ${seconds}`}
            </Tag>
        </>
    );
};

//export default React.memo(TimerDisplay);
export default TimerDisplay;
